import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  url = environment.apiUrl;
  mpUrl= environment.multipagos_url;
  constructor(private http: HttpClient) {

  }

  getClientMovements(clientNumber: number, fromDate: Date, toDate: Date, type: string): Observable<any> {
    return this.http.get(this.url + 'payment?clientNumber=' + clientNumber + '&fromDate=' + fromDate.toISOString() + '&toDate=' + toDate.toISOString() + '&type=' + type);
  }

  validateClientAmount(clientNumber: number, amount: number, listInvoices: string[]): Observable<any> {
    return this.http.post(this.url + 'payment/validate/amount', {
      clientNumber: clientNumber,
      total: amount,
      invoices: listInvoices,

    });

  }

  getPendingPayments(clientNumber:number,fromDate:Date,toDate:Date,status=1){
    return this.http.get(this.url + 'payment/pendings?clientNumber=' + clientNumber + '&fromDate=' + fromDate.toISOString() + '&toDate=' + toDate.toISOString() + '&status=' + status);
  }

  validatePendingPayment(paymentId:string,clientNumber:number,fromDate:Date,toDate:Date,status=1){
    console.log( {
      clientNumber: clientNumber,
      fromDate:fromDate.toISOString(),
      toDate:toDate.toISOString(),
      status:status,
      paymentId: paymentId,
    });
    return this.http.post(this.url + 'payment/pending/apply', {
      clientNumber: clientNumber,
      fromDate:fromDate.toISOString(),
      toDate:toDate.toISOString(),
      status:status,
      paymentId: paymentId,
    });
  }


  /**
   *  <input runat="server" type="hidden" id="url_error"     value=""/>
   <input runat="server" type="hidden" id="hdnMessage"    value=""/>
   <input runat="server" type="hidden" id="s_transm"      value=""/>
   <input runat="server" type="hidden" id="c_referencia"  value=""/>
   <input runat="server" type="hidden" id="t_servicio"    value="231"/>
   <input runat="server" type="hidden" id="t_importe"     value=""/>
   <input runat="server" type="hidden" id="param_c_b_1"   value="10703"/>
   <input runat="server" type="hidden" id="param_c_b_2"   value="0"/>
   <input runat="server" type="hidden" id="param_c_b_3"   value=""/>
   <input runat="server" type="hidden" id="param_c_b_4"   value="1"/>
   <input runat="server" type="hidden" id="param_c_b_5"   value="1"/>
   <input runat="server" type="hidden" id="param_c_b_6"   value="1"/>
   <input runat="server" type="hidden" id="param_c_b_7"   value="0"/>
   <input runat="server" type="hidden" id="param_c_b_8"   value="CreditoyCobranza@Xiga.com.mx"/>
   <input runat="server" type="hidden" id="param_c_b_9"   value=""/>
   <input runat="server" type="hidden" id="param_c_b_10"  value=""/>
   <input runat="server" type="hidden" id="param_c_b_17"  value=""/>
   <input runat="server" type="hidden" id="param_c_b_18"  value="1110"/>
   <input runat="server" type="hidden" id="mp_autosubmit_time"  value="6000" />
   <input runat="server" type="hidden" id="url_forward" value="https://cardsystem.xiga.com.mx/GetPaymentResponse.aspx" />
   *
   *
  */
  sendPaymentToMultiPagos(obj: any) {


    const mapForm = document.createElement('form');

    mapForm.target = '_blank';
    mapForm.setAttribute("method", "post");
    mapForm.setAttribute(
      "action",
      this.mpUrl
    );
    mapForm.setAttribute(
      "id",
     "Form"
    );

    mapForm.append('Content-Type', 'application/x-www-form-urlencoded');
    mapForm.append('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');
    mapForm.style.display = 'none';

    const t_servicio = document.createElement('input');
    t_servicio.type = 'hidden';
    t_servicio.id = "t_servicio";
    t_servicio.setAttribute('value', '231');
    mapForm.append(t_servicio);
    const param_c_b_1 = document.createElement('input');
    param_c_b_1.type = 'hidden';
    param_c_b_1.id = "param_c_b_1";
    param_c_b_1.setAttribute('value', '10703');
    mapForm.append(param_c_b_1);
    const param_c_b_2 = document.createElement('input');
    param_c_b_2.type = 'hidden';
    param_c_b_2.id = "param_c_b_2";
    param_c_b_2.setAttribute('value', '0');
    mapForm.append(param_c_b_2);

    const param_c_b_4 = document.createElement('input');
    param_c_b_4.type = 'hidden';
    param_c_b_4.id = "param_c_b_4";
    param_c_b_4.setAttribute('value', '1');
    mapForm.append(param_c_b_4);
    const param_c_b_5 = document.createElement('input');
    param_c_b_5.type = 'hidden';
    param_c_b_5.id = "param_c_b_5";
    param_c_b_5.setAttribute('value', '1');
    mapForm.append(param_c_b_5);
    const param_c_b_6 = document.createElement('input');
    param_c_b_6.type = 'hidden';
    param_c_b_6.id = "param_c_b_6";
    param_c_b_6.setAttribute('value', '1');
    mapForm.append(param_c_b_6);
    const param_c_b_7 = document.createElement('input');
    param_c_b_7.type = 'hidden';
    param_c_b_7.id = "param_c_b_7";
    param_c_b_7.setAttribute('value', '0');
    mapForm.append(param_c_b_7);
    const param_c_b_8 = document.createElement('input');
    param_c_b_8.type = 'hidden';
    param_c_b_8.id = "param_c_b_8";
    param_c_b_8.setAttribute('value', 'CreditoyCobranza@Xiga.com.mx');
    mapForm.append(param_c_b_8);

    const param_c_b_18 = document.createElement('input');
    param_c_b_18.type = 'hidden';
    param_c_b_18.id = "param_c_b_18";
    param_c_b_18.setAttribute('value', '1110');
    mapForm.append(param_c_b_18);
    const mp_autosubmit_time = document.createElement('input');
    mp_autosubmit_time.type = 'hidden';
    mp_autosubmit_time.id = "mp_autosubmit_time";
    mp_autosubmit_time.setAttribute('value', '6000');
    mapForm.append(mp_autosubmit_time);

    const url_forward_input = document.createElement('input');
    url_forward_input.type = 'hidden';
    url_forward_input.id = "url_forward";
    url_forward_input.setAttribute('value', environment.urlForward);

    mapForm.append(url_forward_input);


    Object.keys(obj).forEach((param) => {
      console.log(param);
      const mapInput = document.createElement('input');
      mapInput.type = 'hidden';
      mapInput.id = param;
      mapInput.setAttribute('value', obj[param]);
      mapForm.append(mapInput);
    });


    document.body.append(mapForm);



    mapForm.submit();
  }

  getPaymentVouchers(clientId: number, fromDate: Date, toDate: Date): Observable<any> {
    return this.http.get(this.url + 'payment/complementos?clientId=' + clientId + '&fromDate=' + fromDate.toISOString() + '&toDate=' + toDate.toISOString());
  }

  getPaymentsConfiguration(): Observable<any> {
    return this.http.get(this.url + 'payment/configuration'); 
  }
}
